export const CalendarViewType = {
  DAY: { type: "day", label: "1 day" },
  DAY3: { type: "day3", label: "3 days" },
  WEEK: { type: "week", label: "Weekly" },
  MONTH: { type: "month", label: "Monthly" },
};
